<script setup lang="ts">
import { cn } from '~/utils';

import ListingEmptyState from '~/components/ListingEmptyState/EmptyState.vue';
import { Button } from '~/components/ui/button';

const emit = defineEmits<{
	'clear-filters': [];
	'view-properties': [];
}>();
</script>

<template>
	<div
		class="flex w-full flex-col items-center justify-center gap-6 px-5 py-20 text-center lg:gap-8 lg:py-32"
	>
		<ListingEmptyState
			:show-badges="false"
			:icon-wrapper-classes="
				cn('size-[60px] rounded-full bg-primary-light-4 p-2 lg:size-[72px]')
			"
			:icon-sub-wrapper-classes="
				cn('size-11 rounded-full bg-primary-light-3 lg:size-[52px]')
			"
			:icon-classes="cn('size-6 text-white lg:size-7')"
			:title-classes="
				cn(
					'font-matter-sq text-[20px] font-normal leading-[150%] text-white lg:text-[24px]'
				)
			"
			:description-classes="
				cn(
					'font-sans !text-[14px] font-normal leading-[150%] text-white-dark-4 lg:!text-[18px]'
				)
			"
			:wrapper-classes="cn('gap-6 lg:gap-8')"
		>
			<template #title>Nenhum Short encontrado</template>
			<template #description>
				Você pode ajustar sua busca ou explorar os mesmos critérios na lista de
				imóveis.
			</template>
		</ListingEmptyState>

		<div
			class="flex w-full max-w-[343px] flex-col gap-5 lg:max-w-none lg:flex-row lg:justify-center"
		>
			<Button
				variant="primary-dark"
				size="md"
				class="h-12 w-full font-sans text-[14px] font-medium lg:w-36"
				@click="$emit('clear-filters')"
			>
				Limpar filtros
			</Button>
			<Button
				variant="secondary-dark"
				size="md"
				class="h-12 w-full font-sans text-[14px] font-medium lg:w-36"
				@click="$emit('view-properties')"
			>
				Ver imóveis
			</Button>
		</div>
	</div>
</template>
